/*
* @Author: liyxt
* @Date: 2019-10-21 14:15:59
 * @LastEditors: bbqin
 * @LastEditTime: 2022-12-26 11:25:06
* @Description: file content
*/
export * from './ajax';
export * from './ajaxsync';
export * from './forwardUrl';
export * as appIcons from './appIcons';
export * from './appUrlUtils';
export * as broadcast from './broadcastChannel';
export * as cacheTools from './cacheTools';
export * as cardCache from './cardCache';
export * as Cipher from './cipher';
export * as keyboard from './keyboard';
export * as regExpUtil from './regExpUtil';
export * from './formDataEncrypt';
export * from './cipherTextTools';
export * from './controlAutoFocus';
export * from './cookie';
export * from './createPageIcon';
export * from './crypto';
export * from './currentLocale';
export * from './date';
export * from './exit';
export * from './findFocusModuleId';
export * from './findParentTd';
// export * from './formDownload';
export * from './getBusinessInfo';
export * from './getDataFormat';
export * from './getFocusRowIndex';
export * from './getGzip';
export * from './getMultiLang';
export * from './getSysFieldid';
export * from './gzip';
export * from './inlt';
export * from './lazyload';
export * from './math';
export * from './message';
export * from './metaCache';
export * from './notification';
export * as pageTo from './pageTo';
// export * from './print';
export * from './render';
export * from './routerrender';
export * from './security';
export * from './simplifyData';
export * as spaCache from './spaCache';
export * from './storage';
export * from './store';
export * from './theme';
export * from './timer';
export * from './window';
export * from './toast';
export * from './utils';
export * from './tokenParseModel';
export * from './getFxExpression';
export * from './setTimeValue';
export * from './handleTemplateRule';
export * as loginUtils from './loginUtils';
export * as deepClone from './deepClone';
export { default as crossTabData } from './postmessage';
export * from './emptyStateCache';
export * from './translateLayoutToMeta';
export * from './createOperationIcon';
export * from './getDimensionCode';
// 就不能这里导出了  放到 components 中 单独导出 老版的api 兼容下  新版暂不考虑
// export { default as promptBox } from './promptBox';

export * from './_unstable';

export { default as Cryptograph } from './cryptograph';
export { default as ClientMonitor } from './shell/clientMonitor';
//export { default as getIframe } from './Iframe';

//export * from './qiankunContext';

export * as microAppUtil from './qiankunContext';

export const tinperClsPrefix = 'wui';

export{ default as isNewVisual } from './isNewVisual';

export function reloadAjax() {
    if (window.__reloadAjax && window.__reloadAjax.length) {
        window.__reloadAjax.forEach(res => {
            res(true);
        });
        window.__reloadAjax = [];
    }
    //检查下有没有没清除掉的遮罩
    // if (document.body.children.length) {
    //     [...document.body.children].forEach(item => {
    //         if (item && item.className && item.className.indexOf('prompt') > -1) {
    //             console.log('遮罩未清除');
    //             // item.remove();
    //         }
    //     });
    // }

}
// import MonitorSDK from './monitor/index';
// console.log(MonitorSDK);
